<template>
	<li class="my-bookmark__item">
		<a :href="post.permLink" class="my-bookmark__item__link #bookmark_list">
			<strong class="my-bookmark__item__title">{{title}}</strong>
			<div class="my-bookmark__item__detail">
				<span class="my-bookmark__item__detail__item"><span class="sr_only">작성자: </span>{{post.creatorName}}</span>
				<span class="my-bookmark__item__detail__item"><span class="sr_only">작성일: </span>{{created}}</span>
				<span class="my-bookmark__item__detail__item"><span class="sr_only">게시된 카페: </span>{{post.cafeName}}</span>
			</div>
		</a>
		<button class="my-bookmark__item__action" @click="deleteBookmark()">
			<span class="ico-delete"><span class="sr_only">북마크 삭제</span></span>
		</button>
	</li>
</template>

<script>
	import { format } from 'date-fns';

	export default {
		props: ['post', 'bookmark'],
		computed: {
			title: function () {
				return this.post.title || '접근할 수 없는 게시물입니다.';
			},
			created: function () {
				return format(new Date(this.post.createdWhen), 'yy.MM.dd');
			}
		},

		methods: {
			deleteBookmark: async function () {
				if (!window.confirm('북마크를 삭제하시겠습니까?')) return;

				try {
					await this.bookmark.delete(this.post.permLink);
				} catch (e) {
					if (e.status === 401)
						Utils.login();

					return;
				}

				this.$emit('delete', this.post.permLink, this.post.tags.map(v => v.id));
			}
		},
	}
</script>
